import { BenefitsCard } from "../components/WACardWrappers";
import React from "react";

const BenefitsIntegration: React.FC = () => {
    return (
        <div className="py-10 max-w-6xl mx-auto">
            <h2 className="lg:text-4xl text-3xl font-semibold max-w-4xl mx-auto w-full text-center px-2 pb-10">Everything You Need to Run Your Business on WhatsApp Efficiently</h2>
            <div className="max-w-6xl w-full mx-auto flex flex-col gap-6">
                <div className="flex gap-3 flex-col lg:flex-row px-5 md:px-10 lg:px-0 pt-10 lg:space-y-0 space-y-10">
                    <BenefitsCard>
                        <div style={{ position: "relative" }}>
                            <img
                                loading="lazy"
                                alt="Hassle-Free Broadcast"
                                className=" h-24 w-24"
                                src="https://assets.gallabox.com/gb-home/integration-pillar/mic-pillar.png"
                                style={{ position: "absolute", top: "-5rem", right: "6rem" }}
                            />
                            <h3 className="text-2xl m-0">Hassle-Free Broadcast</h3>
                            <ul className="p-3 text-left text-gray-500">
                                <li>Segmented broadcasting to send personalised messages</li>
                                <li>Send media-rich marketing messages to your leads</li>
                            </ul>
                        </div>
                    </BenefitsCard>
                    <BenefitsCard>
                        <div style={{ position: "relative" }}>
                            <img
                                loading="lazy"
                                alt="Drip Marketing"
                                className=" h-24 w-24"
                                src="https://assets.gallabox.com/gb-home/integration-pillar/wire-pillar.png"
                                style={{ position: "absolute", top: "-5rem", right: "6rem" }}
                            />
                            <h3 className="text-2xl m-0">Drip Marketing</h3>
                            <ul className="p-3 text-left text-gray-500">
                                <li>Send sequence of messages at intervals on WhatsApp</li>
                                <li>Set up automated reminders based on events</li>
                            </ul>
                        </div>
                    </BenefitsCard>

                    <BenefitsCard>
                        <div style={{ position: "relative" }}>
                            <img
                                loading="lazy"
                                alt="Collect Payments"
                                className=" h-24 w-24"
                                src="https://assets.gallabox.com/gb-home/integration-pillar/wallet-pillar.png"
                                style={{ position: "absolute", top: "-5rem", right: "6rem" }}
                            />
                            <h3 className="text-2xl m-0">Collect Payments</h3>
                            <ul className="p-3 text-left text-gray-500">
                                <li>Collecting payments within WhatsApp to improve cashflow</li>
                                <li>Convert engaging prospects to paying customers.</li>
                            </ul>
                        </div>
                    </BenefitsCard>
                </div>
                <div className="flex gap-3 flex-col lg:flex-row px-5 md:px-10 lg:px-0 pt-10 lg:space-y-0 space-y-10">
                    <BenefitsCard>
                        <div style={{ position: "relative" }}>
                            <img
                                loading="lazy"
                                alt="WhatsApp Shop"
                                className=" h-24 w-24"
                                src="https://assets.gallabox.com/gb-home/integration-pillar/shop-pillar.png"
                                style={{ position: "absolute", top: "-5rem", right: "6rem" }}
                            />
                            <h3 className="text-2xl m-0">WhatsApp Shop</h3>
                            <ul className="p-4 text-left text-gray-500">
                                <li>Set up product catalogs and start selling on WhatsApp in no time. </li>
                                <li>Offer a seamless shopping experience from end-to-end. </li>
                            </ul>
                        </div>
                    </BenefitsCard>
                    <BenefitsCard>
                        <div style={{ position: "relative" }}>
                            <img
                                loading="lazy"
                                alt="ChatGPT on WhatsApp"
                                className=" h-24 w-24"
                                src="https://assets.gallabox.com/gb-home/integration-pillar/gpt-pillar.png"
                                style={{ position: "absolute", top: "-5rem", right: "6rem" }}
                            />
                            <h3 className="text-2xl m-0">ChatGPT on WhatsApp</h3>
                            <ul className="p-4 text-left text-gray-500">
                                <li>Craft your WhatsApp responses with the help of ChatGPT</li>
                                <li>Tweak the tone, or shorten or lengthen the text, as per your needs</li>
                            </ul>
                        </div>
                    </BenefitsCard>

                    <BenefitsCard>
                        <div style={{ position: "relative" }}>
                            <img
                                loading="lazy"
                                alt="Intelligent Chatbot"
                                className=" h-24 w-24"
                                src="https://assets.gallabox.com/gb-home/integration-pillar/bot-pillar.png"
                                style={{ position: "absolute", top: "-5rem", right: "6rem" }}
                            />
                            <h3 className="text-2xl m-0">Intelligent Chatbot</h3>
                            <ul className="p-3 text-left text-gray-500">
                                <li>Keep your customers engaged 24/7 with WhatsApp Chatbot</li>
                                <li>Engage your customers and prospects around the clock with our simple drag-and-drop chatbots</li>
                            </ul>
                        </div>
                    </BenefitsCard>
                </div>
            </div>
        </div>
    );
};

export default BenefitsIntegration;
